export const images = [
    {
        id: 0,
        name: "Before 1",
        imgurl: "assets/beforeandafter/3959304_orig.jpg",
        caption: "1. Before: Large silver filling with cracked tooth"
    },
    {
        id: 1,
        name: "After 1",
        imgurl: "assets/beforeandafter/9710167_orig.jpg",
        caption: "1. After: Replaced silver filling with tooth color filling"
    },
    {
        id: 2,
        name: "Before 2",
        imgurl: "assets/beforeandafter/4292026_orig.jpg",
        caption: "2. Before: Tooth with large decay, over 50% of biting surface affected"
    },
    {
        id: 3,
        name: "After 2",
        imgurl: "assets/beforeandafter/6136726_orig.jpg",
        caption: "2. After: Filled decay with tooth color filling"
    },
    {
        id: 4,
        name: "Before 3",
        imgurl: "assets/beforeandafter/7392094_orig.jpg",
        caption: "3. Before"
    },
    {
        id: 5,
        name: "After 3",
        imgurl: "assets/beforeandafter/7118227_orig.jpg",
        caption: "3. After: Full mouth rehabilitation"
    },
    {
        id :6,
        name: "Before 4",
        imgurl: "assets/beforeandafter/7833552.jpg",
        caption: "4. Before"
    },
    {
        id: 7,
        name: "After 4",
        imgurl: "assets/beforeandafter/7147899.jpg",
        caption: "4. After: #7-10 Porcelain veneers"
    },
    {
        id: 8,
        name: "Before 5",
        imgurl: "assets/beforeandafter/3238184.jpg",
        caption: "5. Before: #8 with Porcelain over metal crown"
    },
    {
        id: 9,
        name: "After 5",
        imgurl: "assets/beforeandafter/9406707.jpg",
        caption: "5. After: One visit all porcelain Cerec crown"
    },
    {
        id: 10,
        name: "Before 6",
        imgurl: "assets/beforeandafter/8062744.jpg",
        caption: "6. Before"
    },
    {
        id: 11,
        name: "After 6",
        imgurl: "assets/beforeandafter/1113463_orig.jpg",
        caption: "6. After: #7-10 Porcelain veneers"
    },
    {
        id: 12,
        name: "Before 7",
        imgurl: "assets/beforeandafter/1304490.jpg",
        caption: "7. Before"
    },
    {
        id: 13,
        name: "After 7",
        imgurl: "assets/beforeandafter/6271082.jpg",
        caption: "7. After"
    }
];